import { ResponseService } from './response.service';
import { ServerResponse } from './../interfaces/server-response.model';
import { Router } from '@angular/router';
import { User } from './../interfaces/user.model';
import { Observable, Subject, BehaviorSubject } from "rxjs/Rx";
import { Response } from '@angular/http';
import { ApiService } from './api.service';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class AuthService {
    public redirectUrl: string = '/company/select';
    public isLogged: boolean;
    public isVerified: Boolean;

    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
        private router: Router,
        private localStorageService: LocalStorageService
    ) { }

    @Output() authenticated = new EventEmitter();
    @Output() verified = new EventEmitter();

    getAuthenticatedEmitter() {
        return this.authenticated;
    }

    getVerifiedEmitter() {
        return this.verified;
    }

    isAuth() {
        return this.apiService.get('/check')
            .map((response) => {

                this.isLogged = (response.status.message === 'user.authenticated');
                
                this.authenticated.emit(this.isLogged);
                return this.isLogged;
            }, (error) => {
                this.responseService.error(error.json());
                this.isLogged = false;
                this.authenticated.emit(this.isLogged);
                return this.isLogged;
            });
    }

    login(data, url, invoice = null) {
        return this.apiService.post('/login', data)
            .map(
                (response) => {
                    const user = this.responseService.success(false, response, 'user');
                    if (user) {
                        if (typeof url !== 'undefined') {
                            this.redirectUrl = url;
                        }
                        this.isLogged = true;
                        this.authenticated.emit(true);
                        if (user.verification_method !== null) {
                            this.localStorageService.set('redirectUrl', this.redirectUrl);
                            this.router.navigateByUrl('/login/verify');
                        } else {
                            this.router.navigateByUrl(this.redirectUrl);
                        }
                        return this.isLogged;
                    }
                    return this.isLogged;
                },
                (error) => {
                    this.responseService.error(error.json());
                    this.isLogged = false;
                    this.authenticated.emit(false);
                    return this.isLogged;
                }
            );
    }

    logout() {
        this.apiService.post('/logout', {}).subscribe(
            (response) => {
                const logout = this.responseService.success(false, response);
                if (logout) {
                    this.isLogged = false;
                    this.redirectUrl = '';
                    this.authenticated.emit(false);
                    this.router.navigateByUrl('/login');
                }
            },
            (error) => {
                this.responseService.error(error);
                this.isLogged = false;
                this.authenticated.emit(false);
                this.router.navigateByUrl('/login');
            }
        );
    }
};


// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts